module.exports = __webpack_public_path__ + "img/phone.d3150c19.svg";